import * as angular from 'angular';
import {ConfigScope} from "./config.base";
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import ShopServiceName, {ShopService} from "../../services/shops/shops.service";
import {apsEnums} from "../../shared/dto/aps.enums";
import template from './scaleConfig.tpl.html';
import isNullOrUndefined from "../../services/utility/isNullOrUndefined";

let requires = [UIUtilityServiceName, LoaderServiceName, ShopServiceName];

interface ScaleConfigScope extends ConfigScope {
  displays: EnumOption[];
  machines: apsViewModels.MachineConfiguration[];
  locations: EnumOption[];
  modes: EnumOption[];
}

export default angular.module('aps.controller.scaleConfig', requires)
  .directive('apsScaleConfig', scaleConfig)
  .name;

function scaleConfig(
  uiUtilityService: UIUtilityService,
  loaderService: LoaderService,
  shopService: ShopService
): angular.IDirective {
  return {
    restrict: 'E',
    template: template,
    link: (scope: ScaleConfigScope) => {
      scope.locations = uiUtilityService.getListOptionsFromEnum(apsEnums.Location, 1);
      scope.modes = uiUtilityService.getListOptionsFromEnum(apsEnums.ScaleMode, 1);
      scope.displays = uiUtilityService.getListOptionsFromEnum(apsEnums.ScaleDisplay, 0);
      if (isNullOrUndefined(scope.vm.config.Display)) {
        scope.vm.config.Display = apsEnums.ScaleDisplay.DifferenceFromTarget;
      }

      let updateMachines = () => {
        if (!scope.vm.location) {
          return;
        }
        let getMachines = shopService.getShopConfiguration(scope.vm.location.id)
          .then(shop => scope.machines = shop.machineConfigurations);
        loaderService.loadingPromise(getMachines);
      };

      updateMachines();

      scope.$watch('vm.location', updateMachines);
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/controllers/equipment/scaleConfig.directive.ts